import { Component, OnInit, inject } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { AuthService } from '../../../common/services/auth.service';
import { concatMap, finalize, switchMap, tap } from 'rxjs';
import { AppStateService } from '../../../common/store/state/app/app.state.service';
import { OrderService } from '../../../common/services/order/order.service';
import { SamlService } from '../../../common/services/saml.service';
import { OrderRoutes } from '../../orders/orders-routes.enum';
import { UserStateService } from '../../../common/store/state/user/user.state.service';
import { SamlResponse } from '../../../common/models/order/saml/saml.model';

@Component({
  selector: 'app-saml-auth',
  standalone: false,
  templateUrl: './saml-auth.component.html',
  styleUrl: './saml-auth.component.scss'
})
export class SamlAuthComponent extends BaseComponent implements OnInit {
  private authService = inject(AuthService);
  private orderService = inject(OrderService);
  private appStateService = inject(AppStateService)
  private samlService = inject(SamlService);
  private userStateService = inject(UserStateService);

  uniqueId: string | null = null;
  samlData: any = null;
  ngOnInit(): void {
    if (this.userStateService.getIsLoggedIn()) {
      console.log('User already logged in, redirecting to service information');
      return;
    }
    // Grab uniqueId from query parameters
    this.uniqueId = this.route.snapshot.queryParamMap.get('uniqueId');

    if (this.uniqueId) {
      console.log('SAML Auth - Unique ID received:', this.uniqueId);
      // First fetch token and session, then get SAML data
      this.fetchTokenAndSession();
    } else {
      console.warn('SAML Auth - No uniqueId found in query parameters');
    }
  }

  fetchTokenAndSession() {
    if (this.uniqueId) {
      const spinnerLabel = 'Fetching session and token...';
      this.spinnerService.setLoading(true, spinnerLabel);

      this.subscriptions.add(this.authService.fetchToken().pipe(
        concatMap(() => this.authService.fetchSession()),
        tap((session) => this.appStateService.setSession(session)),
        concatMap(() => this.orderService.processSAML(this.uniqueId)),
        concatMap((response) => this.samlService.processSamlResponse(response)),
        switchMap((samlResponse) => this.redirect(samlResponse)),
        finalize(() => this.spinnerService.setLoading(false, spinnerLabel))
      ).subscribe());
    }
  }

  private redirect(samlResponse: SamlResponse) {
    const accounts = samlResponse.ApiResponses.StartOrder.Accounts;
    const retailers = samlResponse.ApiResponses.StartOrder.Retailers;
    const salesPersons = samlResponse.ApiResponses.StartOrder.SalesPersons;
    let nextPage = samlResponse.ApiResponses?.MetaData?.NextPage ?? -1;
    if (accounts && accounts.length > 1 || retailers && retailers.length > 1 || salesPersons && salesPersons.length > 1) {
      nextPage = 1;
    }
    let route: string = OrderRoutes.WELCOME;
    if (nextPage == 1) {
      route = OrderRoutes.ORDER_SETUP
    } else if (nextPage == 2) {
      route = OrderRoutes.SERVICE_INFORMATION
    }
    return this.router.navigate([route])
  }
}
